'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["handleClone", "handleRemove", "isReadOnly", "isTitleVisible"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FilterEditorOrGroupHeader extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        handleClone,
        handleRemove,
        isReadOnly,
        isTitleVisible
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (isReadOnly && !isTitleVisible) {
      return null;
    }
    return /*#__PURE__*/_jsxs(UIFlex, Object.assign({
      align: "baseline",
      className: "p-top-3 p-bottom-1",
      direction: "row",
      justify: "between"
    }, rest, {
      children: [isTitleVisible && /*#__PURE__*/_jsx(Text, {
        as: "h6",
        margin: "0",
        padding: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditorOperatorDisplayList.separatorOr"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-grow-1"
      }), !isReadOnly && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIButton, {
          onClick: handleClone,
          size: "small",
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterEditorOperatorDisplayList.actionClone"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-selenium-test": "delete-filter-group",
          onClick: handleRemove,
          size: "small",
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterEditorOperatorDisplayList.actionDelete"
          })
        })]
      })]
    }));
  }
}
FilterEditorOrGroupHeader.propTypes = {
  handleClone: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  isTitleVisible: PropTypes.bool
};
export default FilterEditorOrGroupHeader;